<template>
  <section
    id="EmptyState"
    class="container empty-state"
    data-module="empty-state"
  >
    <div class="content">
      <div class="image">
        <img
          class="image__optin"
          :src="img"
        />
      </div>
      <div class="text">
        <h3 class="tit tit-m">
          {{ title }}
        </h3>
        <p
          class="subtitle"
          v-html="subtitle"
        ></p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    img: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.empty-state {
  padding: 0;
  .content {
    background: $lb-white;
    padding: 90px 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    .text {
      margin-left: 50px;
      text-align: left;
      .tit {
        font-style: normal;
        font-weight: bold;
        font-size: 32px;
        line-height: 45px;
        color: #000000;
      }
      .subtitle {
        font-style: normal;
        font-weight: $lb-medium;
        font-size: $size-normal;
        line-height: 24px;
        margin-top: 18px;
        opacity: 0.6;
        white-space: pre-line;
      }
    }
  }
}

@include media-breakpoint-down(md) {
  .empty-state {
    .content {
      flex-direction: column;
      .image {
        margin-bottom: 30px;
      }
      .text {
        margin: 0;
        text-align: center;
      }
    }
  }
}

@include media-breakpoint-down(sm) {
  .empty-state {
    .content {
      padding: 30px 20px;
      .image {
        margin-bottom: 30px;
      }
      .text {
        .tit {
          font-size: 18px;
          line-height: 25px;
        }
        .subtitle {
          font-size: $size-small;
        }
      }
    }
  }
}
</style>
